export const UPDATE_DESIGN_OPTIONS = 'fabricDesign/*/UpdateOptions';
export const SET_UPLOADED_IMAGE = 'fabricDesign/*/SetUploadedImage';
